const TMSIssueChart = (props) => {
  return (
    <div>{<div dangerouslySetInnerHTML={{ __html: props.chartData }} />}</div>
  );
};

export { TMSIssueChart };
